import { inject, Pipe, PipeTransform } from '@angular/core';

import { deriveLabel } from '../../functions/derive-label/derive-label';
import { VerticalConfigResolver } from '../../vertical-config-resolver/vertical-config-resolver';

@Pipe({
  name: 'verticalLabel',
  standalone: true,
  pure: false,
})
export class VerticalLabelPipe implements PipeTransform {
  private resolver = inject(VerticalConfigResolver, { optional: true });

  public transform(key: string, defaultLabel: string): string {
    const config = this.resolver?.resolve();
    return (config && deriveLabel(key, config, defaultLabel)) ?? defaultLabel;
  }
}
